import React from 'react'

import {useAppDispatch, useAppSelector} from '../hooks/redux'
import {hideToast} from '../redux/features/toast'

import ToastLayout from '../../../commons/src/components/toast-layout'
import Toast from '../../../commons/src/components/toast-layout/Toast'
import PageLayout from '../components/page-layout'

import FooterPartial from './footer-partial'
import NavigationPartial from './navigation-partial'

interface Props {
  children: React.ReactNode
  hideFooter?: boolean
  fixedHeight?: boolean
}

const PagePartial = ({children, hideFooter = false, fixedHeight = false}: Props) => {
  const dispatch = useAppDispatch()
  const toasts = useAppSelector(state => state.toast.toasts)

  return (
    <NavigationPartial>
      <PageLayout
        footer={!hideFooter ? <FooterPartial /> : undefined}
        fixedHeight={fixedHeight}
        toasts={
          <ToastLayout>
            {toasts.map(toast => {
              const hide = () => dispatch(hideToast({id: toast.id}))

              return (
                <Toast
                  key={toast.id}
                  type={toast.type}
                  onClose={hide}
                  timeout={toast.timeout}
                  onTimeout={hide}
                >
                  {toast.content}
                </Toast>
              )
            })}
          </ToastLayout>
        }
      >
        {children}
      </PageLayout>
    </NavigationPartial>
  )
}

export default PagePartial
